export type GeneratedDocumentStatus =
  | 'draft'
  | 'reviewed'
  | 'finalized'
  | 'archived';

export type GeneratedDocumentSource =
  | 'manual'
  | 'template'
  | 'ai'
  | 'import';

const statusLabels:
  Record<
    GeneratedDocumentStatus,
    string
  > = {
    draft:
      'Rascunho',

    reviewed:
      'Revisado',

    finalized:
      'Finalizado',

    archived:
      'Arquivado',
  };

const sourceLabels:
  Record<
    GeneratedDocumentSource,
    string
  > = {
    manual:
      'Manual',

    template:
      'Modelo',

    ai:
      'IA',

    import:
      'Importado',
  };

export function normalizeGeneratedDocumentStatus(
  value: unknown
): GeneratedDocumentStatus {
  const normalized =
    String(value ?? '')
      .trim()
      .toLowerCase();

  if (
    [
      'generated',
      'review',
      'reviewed',
    ].includes(normalized)
  ) {
    return 'reviewed';
  }

  if (
    [
      'sent',
      'finalized',
    ].includes(normalized)
  ) {
    return 'finalized';
  }

  if (
    normalized ===
    'archived'
  ) {
    return 'archived';
  }

  return 'draft';
}

export function normalizeGeneratedDocumentSource(
  value: unknown,
  hasTemplate = false
): GeneratedDocumentSource {
  const normalized =
    String(value ?? '')
      .trim()
      .toLowerCase();

  if (
    normalized ===
      'template' ||
    normalized ===
      'ai' ||
    normalized ===
      'import' ||
    normalized ===
      'manual'
  ) {
    return normalized;
  }

  return hasTemplate
    ? 'template'
    : 'manual';
}

export function getGeneratedDocumentStatusLabel(
  value: unknown
) {
  return statusLabels[
    normalizeGeneratedDocumentStatus(
      value
    )
  ];
}

export function getGeneratedDocumentSourceLabel(
  value: unknown,
  hasTemplate = false
) {
  return sourceLabels[
    normalizeGeneratedDocumentSource(
      value,
      hasTemplate
    )
  ];
}

export function getGeneratedDocumentVersionLabel(
  value: unknown
) {
  const number =
    Number(value);

  return `v${
    Number.isFinite(number) &&
    number >= 1
      ? Math.trunc(number)
      : 1
  }`;
}

export function isGeneratedDocumentFinalized(
  value: unknown
) {
  return (
    normalizeGeneratedDocumentStatus(
      value
    ) === 'finalized'
  );
}